import { render } from "./InactiveScreen.vue?vue&type=template&id=1ce15872&scoped=true"
import script from "./InactiveScreen.vue?vue&type=script&lang=js"
export * from "./InactiveScreen.vue?vue&type=script&lang=js"

import "./InactiveScreen.vue?vue&type=style&index=0&id=1ce15872&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Sites/progressive_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce15872"]])

export default __exports__